import React from 'react';
import { FDBox } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { stripeNonSecretKey } from 'Consts/keys';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { PromoCodeInputContextProvider } from 'Context/PromoCodeInputContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import EstatePlanningBuyPaymentMetaOverride
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuyPayment/Template/Layout/EstatePlanningBuyPaymentMetaOverride';
import EstatePlanningBuyPaymentStepLayout from './Layout/EstatePlanningBuyPaymentLayout';

const EstatePlanningBuyPaymentStep = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  const { setModalCollection } = useModalContext();

  return (
    <StripeProvider apiKey={stripeNonSecretKey}>
      <Elements fonts={[{ family: 'Euclid Square', src: 'url(https://static.facetwealth.com/app/fonts/euclid-square-500-normal.otf)', weight: '500' }]}>
        <PromoCodeInputContextProvider>
          <MetaFormInline
            LayoutProps={{ hideErrorList: true }}
            metaOverrideSet={EstatePlanningBuyPaymentMetaOverride}
            component={FDBox/* Allows the background to be visible, removes padding */}
            resource={resource}
            layout={EstatePlanningBuyPaymentStepLayout}
            onSubmit={setModalCollection}
            noIndividualSubmitButtons
          />
        </PromoCodeInputContextProvider>
      </Elements>
    </StripeProvider>
  );
};

EstatePlanningBuyPaymentStep.defaultProps = {};

EstatePlanningBuyPaymentStep.propTypes = {};

export { EstatePlanningBuyPaymentStep };
